import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/products/itemCard/ItemCard.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/products/mainParent/ProductsPage.js");
